var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkflows(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_545_51667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.1495 29.2433C39.6406 29.2433 39.2281 29.6559 39.2281 30.1648V38.3467C39.2263 39.8729 37.9898 41.1097 36.4636 41.1112H10.6075C9.08124 41.1097 7.84478 39.8729 7.84298 38.3467V14.3335C7.84478 12.8077 9.08124 11.5709 10.6075 11.5691H18.7893C19.2983 11.5691 19.7108 11.1565 19.7108 10.6476C19.7108 10.1389 19.2983 9.72607 18.7893 9.72607H10.6075C8.064 9.72895 6.00288 11.7901 6 14.3335V38.347C6.00288 40.8905 8.064 42.9516 10.6075 42.9545H36.4636C39.007 42.9516 41.0682 40.8905 41.071 38.347V30.1648C41.071 29.6559 40.6585 29.2433 40.1495 29.2433Z",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7061 7.35472C39.0866 5.73527 36.4611 5.73527 34.8416 7.35472L18.4016 23.7947C18.289 23.9074 18.2076 24.047 18.1651 24.2004L16.0032 32.0053C15.9143 32.3253 16.0047 32.668 16.2394 32.9031C16.4744 33.1378 16.8171 33.2281 17.1371 33.1396L24.9421 30.9773C25.0954 30.9348 25.2351 30.8535 25.3477 30.7408L41.7874 14.3005C43.4043 12.6799 43.4043 10.0566 41.7874 8.43604L40.7061 7.35472ZM20.4095 24.3937L33.8643 10.9385L38.2036 15.2778L24.7484 28.733L20.4095 24.3937ZM19.5427 26.133L23.0095 29.6001L18.2141 30.9287L19.5427 26.133ZM40.4843 12.9974L39.507 13.9747L35.1674 9.63506L36.145 8.65777C37.0446 7.75824 38.5031 7.75824 39.4027 8.65777L40.4843 9.73908C41.3824 10.6397 41.3824 12.0972 40.4843 12.9974Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_545_51667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkflows);
export default __webpack_public_path__ + "static/media/workflows.1cce9276b8d931ac0c5699278c0db692.svg";
export { ForwardRef as ReactComponent };